import React from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { Badge } from '../../components/Badge'
import { SchoolGenders } from '../../types/School.types'

const StyledGenderBadge = styled(Badge).attrs({
  title: 'Gender',
  titleBackgroundColor: STYLES.COLOR_BITTER_SWEET_RED,
  textBackgroundColor: '#fbe0e0',
})``

interface IGenderBadgeProps {
  className?: string
  children: SchoolGenders
}

const GenderBadge: React.FC<IGenderBadgeProps> = ({ children, className }) => {
  const displayText =
    {
      [SchoolGenders.FEMALE]: 'Girls',
      [SchoolGenders.MALE]: 'Boys',
    }[children] || children
  return (
    <StyledGenderBadge className={className}>{displayText}</StyledGenderBadge>
  )
}

export { GenderBadge }
